import { useEffect, useState } from "react";

import {
  metabolicReadQuery,
  type GlucoseReading,
  type NutritionEntry,
} from "@jackedlogs/shared";

import { apiFetch } from "./api";

// The web console's metabolic resource — the glucose + nutrition rows the
// Health Connect merge imported, for the shared MetabolicCard. Online only
// (no offline outbox; that stays on mobile), read-only, small volumes. Same
// endpoints as the mobile useMetabolic, and the same windowing — no longer
// by convention: both build the query from metabolicReadQuery (shared), so
// the two cards cannot drift to different spans. Newest-first from the API;
// the card reverses for the chart.

export type UseMetabolicWeb = {
  glucose: GlucoseReading[];
  nutrition: NutritionEntry[];
  loading: boolean;
};

export function useMetabolicWeb(): UseMetabolicWeb {
  const [glucose, setGlucose] = useState<GlucoseReading[]>([]);
  const [nutrition, setNutrition] = useState<NutritionEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      setLoading(true);
      const q = metabolicReadQuery();
      try {
        const [g, n] = await Promise.all([
          apiFetch<{ items: GlucoseReading[] }>(`/api/me/glucose?${q}`),
          apiFetch<{ items: NutritionEntry[] }>(`/api/me/nutrition?${q}`),
        ]);
        if (cancelled) return;
        setGlucose(g.items);
        setNutrition(n.items);
      } catch {
        // Offline / no data yet — leave empty, the card shows its hint.
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { glucose, nutrition, loading };
}
